import { rem } from 'polished'
import styled from 'styled-components'

import { boxShadowAppear, boxShadowDisappear } from '../DragAndDrop/styles'
import { mediaQueryUp } from 'components/utils/breakpoint'

const PinArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${rem(4)};

  @container (min-width: 640px) {
    margin-right: ${rem(8)};
  }
`

const BaseCompactCardContainer = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.L};
  overflow: hidden;
  flex: 1;
  display: grid;
  grid-template-areas:
    "content"
    "comment";
  grid-template-rows: auto auto;
  break-inside: avoid-page;

  .drag-overlay & {
    animation: ${boxShadowAppear} 0.2s forwards ease-out;
  }

  .drag-overlay.dropped & {
    animation: ${boxShadowDisappear} 0.15s forwards ease-out;
  }

  ${mediaQueryUp.desktop} {
    &:hover {
      box-shadow: ${props => props.theme.shadow.bottom.medium};
    }
  }
`

const CompactCardContent = styled.div`
  grid-area: content;
  padding: ${rem(12)};
  min-height: ${rem(48)};

  @container (min-width: 640px) {
    padding: ${rem(16)} ${rem(20)};
  }
`

const CompactCardComment = styled.div`
  grid-area: comment;
  padding: ${rem(8)} ${rem(24)};
  display: flex;
  align-items: center;
  overflow: hidden;
  border-top: 1px solid ${props => props.theme.palette.neutral.default.five};
`

const CompactCardAndPinLayoutBase = styled.div`
  display: flex;
  background: transparent;
  flex-direction: row;
  align-items: center;
  gap: 0;
  margin-top: ${rem(12)};

  @container (min-width: 640px) {
    margin-top: ${rem(16)};
  }
`

export const CompactCardLayout = BaseCompactCardContainer as typeof BaseCompactCardContainer & {
  Content: typeof CompactCardContent
  Comment: typeof CompactCardComment
}

CompactCardLayout.Content = CompactCardContent
CompactCardLayout.Comment = CompactCardComment

export const CompactCardAndPinLayout = CompactCardAndPinLayoutBase as typeof CompactCardAndPinLayoutBase & {
  Pin: typeof PinArea
  CardContainer: typeof BaseCompactCardContainer
}
CompactCardAndPinLayout.Pin = PinArea
CompactCardAndPinLayout.CardContainer = BaseCompactCardContainer
